import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button } from '@ipc/ipc-components';
import DateFnsUtils from '@date-io/date-fns';
import Grid from '@material-ui/core/Grid';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import locale from 'date-fns/locale/en-US';
import moment from 'moment';
import {
  getData,
  getColumns,
  getIsLoading,
} from '../redux/selectors/BalanceOnHandPastInfoSelectors';
import ListTable from '../../../../../common/tables/ListTable';
import TableDefinitions from '../../../../../common/TableDefinitions';
import { tableLoadData } from '../../../../../common/tables/actions/ListTableActions';
import { getAssetType } from '../../../../../common/asset-types/redux/selectors/AssetTypesSelectors';
import { getClickedRowOnTable } from '../../../../../common/tables/reducers/selectors/ListTableSelectors';
import { BalanceOnHandPastInfoContainerStyle } from './BalanceOnHandPastInfoContainer.styles';

if (locale && locale.options) {
  locale.options.weekStartsOn = 1;
}

class BalanceOnHandPastInfoContainer extends Component {
  constructor(props) {
    super(props);
    this.handleStartBohDate = this.handleStartBohDate.bind(this);
    this.handleEndBohDate = this.handleEndBohDate.bind(this);
    this.applyDateRange = this.applyDateRange.bind(this);
    this.state = {
      currentDate: moment(),
      endDate: moment(new Date()).format('YYYY-MM-DD'),
      startDate: moment().subtract(10, 'days').format('YYYY-MM-DD'),
    };
    this.props.tableLoadData(
      { tableId: 'VIEW_BOH_PAST_INFO' },
      this.props.appContext.appContext,
      {
        impcCode: this.props.clickedRow.impc,
        startDate: moment().subtract(10, 'days').format('YYYY-MM-DD'),
        endDate: moment(new Date()).format('YYYY-MM-DD'),
      },
    );
  }

  componentDidUpdate(prevProps) {
    const start = moment(this.state.startDate).format('YYYY-MM-DD');
    const end = moment(this.state.endDate).format('YYYY-MM-DD');
    if (this.props.clickedRow !== prevProps.clickedRow) {
      this.props.tableLoadData(
        { tableId: 'VIEW_BOH_PAST_INFO' },
        this.props.appContext.appContext,
        {
          impcCode: this.props.clickedRow.impc,
          startDate: start,
          endDate: end,
        },
      );
    }
  }

  handleStartBohDate(value) {
    this.setState({
      startDate: value,
    });
  }

  handleEndBohDate(value) {
    this.setState({
      endDate: value,
    });
  }

  applyDateRange() {
    const start = moment(this.state.startDate).format('YYYY-MM-DD');
    const end = moment(this.state.endDate).format('YYYY-MM-DD');
    this.props.tableLoadData(
      { tableId: 'VIEW_BOH_PAST_INFO' },
      this.props.appContext.appContext,
      {
        impcCode: this.props.clickedRow.impc,
        startDate: start,
        endDate: end,
      },
    );
  }

  render() {
    return (
      <div className="general-content-container">
        <div className="general-half-left-container">
          <table>
            <tbody>
              <tr>
                <td className="selected-impc">
                  <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
                    <Grid container justify="space-around">
                      <KeyboardDatePicker
                        autoOk
                        disableToolbar
                        variant="inline"
                        format="dd-MM-yyyy"
                        margin="normal"
                        id="date-picker-inline"
                        label="Past BoH start date"
                        value={this.state.startDate}
                        onChange={this.handleStartBohDate}
                        KeyboardButtonProps={{
                        'aria-label': 'change date',
                      }}
                      />
                    </Grid>
                  </MuiPickersUtilsProvider>
                </td>
              </tr>
              <tr>
                <td className="selected-impc">
                  <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
                    <Grid container justify="space-around">
                      <KeyboardDatePicker
                        autoOk
                        disableToolbar
                        variant="inline"
                        format="dd-MM-yyyy"
                        margin="normal"
                        id="date-picker-inline"
                        label="Past BoH stop date"
                        value={this.state.endDate}
                        onChange={this.handleEndBohDate}
                        minDate={this.state.startDate}
                        maxDate={this.state.currentDate}
                        KeyboardButtonProps={{
                        'aria-label': 'change date',
                      }}
                      />
                    </Grid>
                  </MuiPickersUtilsProvider>
                </td>
              </tr>
              <tr>
                <td>
                  <Grid container justify="space-around">
                    <Button onClick={this.applyDateRange}>Update</Button>
                  </Grid>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="general-half-right-container">
          <BalanceOnHandPastInfoContainerStyle>
            <ListTable
              listId={TableDefinitions.VIEW_BOH_PAST_INFO.id}
              loading={this.props.isLoading}
              columns={this.props.columns}
              data={this.props.data}
            />
          </BalanceOnHandPastInfoContainerStyle>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    columns: getColumns(state),
    appContext: getAssetType(state),
    clickedRow: getClickedRowOnTable(state),
    isLoading: getIsLoading(state),
  };
}

BalanceOnHandPastInfoContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  appContext: PropTypes.objectOf(PropTypes.string),
  tableLoadData: PropTypes.func,
  clickedRow: PropTypes.objectOf(PropTypes.shape),
  isLoading: PropTypes.bool,
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
  tableLoadData,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(BalanceOnHandPastInfoContainer);
